import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import { CreateChancel, Input } from 'components';
import { FindLoad, FindSuccessItem, useModal } from 'utils';
import { httpRequestsOnSuccessActions, systemActions } from 'store';

export const CreateEditJobTitle = ({ info, afterSuccess }) => {
    const dispatch = useDispatch();
    const ACTION_TYPE = info ? 'EDIT_JOB_BY_ID_GLOBAL' : 'CREATE_JOB_GLOBAL';
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { close } = useModal();

    const {
        control,
        handleSubmit,
        reset,
    } = useForm({
        defaultValues: {
            name: '',
        }
    });

    useEffect(() => {
        if (info) {
            reset({
                name: info.name || '',
            });
        }
    }, [info, reset]);

    useEffect(() => {
        if (!!success) {
            if (afterSuccess) afterSuccess();
            close();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            reset();
        }
    }, [success]);

    function handleSave(data) {
        if (info) {
            dispatch(systemActions.editJobByIdGlobal(data, info.id));
        } else {
            dispatch(systemActions.createJobGlobal(data));
        }
    }

    return (
        <div style={{ width: 400 }}>
            <p className="modal-header-title">{info ? 'Edit Job Title' : 'Add Job Title'}</p>
            <form onSubmit={handleSubmit(handleSave)}>
                <div className="modal-body-wrapper">
                    <Input
                        name="name"
                        label="Job Title*"
                        variant="outlined"
                        control={control}
                        maxLength={50}
                        rules={{
                            required: 'Job title is required.',
                            maxLength: {
                                value: 50,
                                message: 'Max length is 50 characters.',
                            },
                        }}
                    />
                </div>

                <CreateChancel
                    type="submit"
                    loader={!!loader.length}
                    create={info ? 'Save' : 'Add'}
                    chancel={'Cancel'}
                    onClose={close}
                    buttonWidth="100%"
                />
            </form>
        </div>
    );
};
